import { useTranslation } from 'react-i18next';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { handleErrorToast, handleSuccessToast } from 'src/components/molecules';
import { PageHeaderWithActions } from 'src/components/molecules/PageHeaderWithActions';
import {
  useMyAccountQuery,
  useUpdateReporterUserSettingsMutation,
} from 'src/graphql';
import { StyledLink } from '../ReportingLayout.styles';
import { ReportingSettingsContainer } from '../ReportingSettingsContainer/ReportingSettingsContainer';
import { CardContainer } from './ReportSettings.styles';

export const ReportingSettings = () => {
  const { t } = useTranslation();
  const { data: accountSettings, refetch: refetchAccount } =
    useMyAccountQuery();

  const updateReporterUserSettings = useUpdateReporterUserSettingsMutation({
    onSuccess: () => {
      refetchAccount();
      handleSuccessToast({
        toastMessage: t('reporting.settings.updatedSettingsSuccess'),
      });
    },
    onError: () => {
      handleErrorToast({
        toastMessage: t('reporting.settings.updatedSettingsFailure'),
      });
    },
  });

  const messageSettings = [
    {
      title: t('reporting.settings.messageSettings.autoTranslationTitle'),
      descriptions: [
        t('reporting.settings.messageSettings.autoTranslationDescription1'),
        t('reporting.settings.messageSettings.autoTranslationDescription2'),
      ],
      isEnabled: Boolean(accountSettings?.myAccount?.translationEnabled),
      onClick: (translationEnabled: boolean) =>
        updateReporterUserSettings.mutate({
          patchData: {
            translationEnabled,
            notificationsEnabled: Boolean(
              accountSettings?.myAccount?.notificationsEnabled,
            ),
          },
        }),
    },
  ];

  const notificationSettings = [
    {
      title: t('reporting.settings.notificationSettings.emailTitle'),
      descriptions: [
        t('reporting.settings.notificationSettings.emailDescription'),
      ],
      isEnabled: Boolean(accountSettings?.myAccount?.notificationsEnabled),
      onClick: (notificationsEnabled: boolean) =>
        updateReporterUserSettings.mutate({
          patchData: {
            translationEnabled: Boolean(
              accountSettings?.myAccount?.translationEnabled,
            ),
            notificationsEnabled,
          },
        }),
    },
  ];

  return (
    <>
      <StyledLink to="/reporting/reports" data-testid="report-back-button">
        <StyledIcon className={'uil uil-angle-left'} size="28px" />
        {t('public.PublicReport.backToReports')}
      </StyledLink>
      <PageHeaderWithActions title={t('reporting.settings.title')} />
      <CardContainer>
        <ReportingSettingsContainer
          header={t('reporting.settings.messageSettings.header')}
          subHeader={t('reporting.settings.messageSettings.subHeader')}
          settings={messageSettings}
        />
      </CardContainer>
      <CardContainer>
        <ReportingSettingsContainer
          header={t('reporting.settings.notificationSettings.header')}
          subHeader={t('reporting.settings.notificationSettings.subHeader')}
          settings={notificationSettings}
        />
      </CardContainer>
    </>
  );
};
